import { render, staticRenderFns } from "./TradingViewChart.vue?vue&type=template&id=451f1e9a&scoped=true"
import script from "./TradingViewChart.vue?vue&type=script&lang=js"
export * from "./TradingViewChart.vue?vue&type=script&lang=js"
import style0 from "./TradingViewChart.vue?vue&type=style&index=0&id=451f1e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f1e9a",
  null
  
)

export default component.exports